package kangaroorewards.appsdk.core.utils.language

const val PREFERRED_LANGUAGE = "preferred_language"